module.exports = __webpack_public_path__ + "static/media/muramur_logo.0a185bf9.png";